export const ASC_SORTED_COLUMNS = ['loan_officer_name', 'loan_officer_company', 'borrower_name'];

export const FILTERS = [
  { key: 'loan_officer.name', title: 'loan_officer_name' },
  { key: 'loan_officer.nmls', title: 'loan_officer_nmls' },
  { key: 'company.license', title: 'company_license' },
  { key: 'company.organization_type', title: 'company_type' },
  { key: 'company.address_state', title: 'company_state' },
  { key: 'address.state', title: 'address_state' },
  { key: 'address.city', title: 'address_city' },
  { key: 'address.zip', title: 'address_zip' },
  { key: 'address.county', title: 'address_county' },
  { key: 'financial.loan_type', title: 'loan_type' },
  { key: 'financial.loan_purpose', title: 'loan_purpose' },
  { key: 'financial.rate_type', title: 'rate_type' },
];

export const RANGE_FILTERS = [
  { key: 'financial.completion_date', title: 'completion_date' },
  { key: 'financial.loan_amount', title: 'loan_amount' },
  { key: 'financial.mortgage_term', title: 'mortgage_term' },
  { key: 'financial.sale_amount', title: 'sale_amount' },
  { key: 'financial.rate', title: 'rate' },
  { key: 'financial.ltv', title: 'ltv' },
];
